import type { InstrumentSpec } from './types'

// Editable defaults. Point values are typical retail-CFD ballparks; the user can
// override per their broker. JP225 is JPY-quoted — treated as USD-equivalent for
// MVP practice (a proper FX conversion is a Phase 6 item).

export const INSTRUMENTS: Record<string, InstrumentSpec> = {
  XAUUSD: {
    symbol: 'XAUUSD',
    displayName: 'Gold',
    valuePerPointPerLot: 100, // 1 lot = 100 oz; $1 move = $100
    priceStep: 0.01,
    lotStep: 0.01,
    minLot: 0.01,
    spreadPoints: 0.3,
    commissionPerLotPerSide: 0,
    slippagePoints: 0,
    quoteCurrency: 'USD',
  },
  USDJPY: {
    symbol: 'USDJPY',
    displayName: 'USD/JPY',
    // JPY-quoted: $ value of a 1.00 move per lot ≈ contract/price ≈ 100000/150.
    // MVP constant (drifts with the rate; editable), like JP225.
    valuePerPointPerLot: 667,
    priceStep: 0.001,
    lotStep: 0.01,
    minLot: 0.01,
    spreadPoints: 0.015, // ~1.5 pips
    commissionPerLotPerSide: 0,
    slippagePoints: 0,
    quoteCurrency: 'JPY',
  },
  BTCUSD: {
    symbol: 'BTCUSD',
    displayName: 'Bitcoin',
    valuePerPointPerLot: 1, // 1 lot = 1 BTC; $1 move = $1
    priceStep: 0.1,
    lotStep: 0.01,
    minLot: 0.01,
    spreadPoints: 20,
    commissionPerLotPerSide: 0,
    slippagePoints: 0,
    quoteCurrency: 'USD',
  },
  US500: {
    symbol: 'US500',
    displayName: 'S&P 500',
    valuePerPointPerLot: 1,
    priceStep: 0.1,
    lotStep: 0.1,
    minLot: 0.1,
    spreadPoints: 0.5,
    commissionPerLotPerSide: 0,
    slippagePoints: 0,
    quoteCurrency: 'USD',
  },
  NAS100: {
    symbol: 'NAS100',
    displayName: 'Nasdaq 100',
    valuePerPointPerLot: 1,
    priceStep: 0.1,
    lotStep: 0.1,
    minLot: 0.1,
    spreadPoints: 1.5,
    commissionPerLotPerSide: 0,
    slippagePoints: 0,
    quoteCurrency: 'USD',
  },
  US30: {
    symbol: 'US30',
    displayName: 'Dow 30',
    valuePerPointPerLot: 1,
    priceStep: 1,
    lotStep: 0.1,
    minLot: 0.1,
    spreadPoints: 3,
    commissionPerLotPerSide: 0,
    slippagePoints: 0,
    quoteCurrency: 'USD',
  },
  JP225: {
    symbol: 'JP225',
    displayName: 'Nikkei 225',
    valuePerPointPerLot: 1,
    priceStep: 1,
    lotStep: 0.1,
    minLot: 0.1,
    spreadPoints: 8,
    commissionPerLotPerSide: 0,
    slippagePoints: 0,
    quoteCurrency: 'JPY',
  },
}

export function getInstrument(symbol: string): InstrumentSpec {
  const s = INSTRUMENTS[symbol]
  if (s) return s
  // Fallback generic spec so unknown symbols still work.
  return {
    symbol,
    displayName: symbol,
    valuePerPointPerLot: 1,
    priceStep: 0.01,
    lotStep: 0.01,
    minLot: 0.01,
    spreadPoints: 0,
    commissionPerLotPerSide: 0,
    slippagePoints: 0,
    quoteCurrency: 'USD',
  }
}
